import { render, staticRenderFns } from "./uploadFiles.vue?vue&type=template&id=30ee6290&"
import script from "./uploadFiles.vue?vue&type=script&lang=js&"
export * from "./uploadFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports